import React from 'react';
import {FormattedMessage} from 'react-intl'
function FormattedOption({value, children}) {
    return <FormattedMessage id={children}>
        {(message) => <option value={value}>{message}</option>}
    </FormattedMessage>
}

export default FormattedOption;

